import { useLocalePathPrefix, useAppPathPrefix } from '../getWebsiteUrl'

const locale = process.env.GATSBY_INTL_LOCALE

export const removeLocaleFromPathname = (pathname) => {
  if (!useLocalePathPrefix) return pathname
  return pathname.replace(`/${locale}/`, '/')
    ?.replaceAll('/app/', '/')
}

export const removeDuplicateLocaleFromPathname = (pathname = '') => {
  if (!useLocalePathPrefix && !useAppPathPrefix) return pathname

  return pathname
    ?.replace(`/${locale}/${locale}/`, `/${locale}/`)
    ?.replace('/app/app/', '/app/')
}
